import xmlFormat from "xml-formatter";

export const isXmlString = (str) => {
  if (typeof str !== "string") return false;
  const trimmed = str.trim();
  return trimmed.startsWith("<") && trimmed.includes(">");
};

export const formatXmlString = (xmlString) => {
  if (typeof xmlString !== "string") return xmlString;

  try {
    return xmlFormat(xmlString.trim(), {
      indentation: "  ",
      collapseContent: true,
      lineSeparator: "\n",
      throwOnFailure: false,
    });
  } catch (error) {
    return xmlString.trim();
  }
};

export const extractXmlContent = (data) => {
  // If the data itself is a string and looks like XML, format it directly
  if (typeof data === "string" && isXmlString(data)) {
    return formatXmlString(data);
  }

  // Check if data has expected_configuration key with XML content
  if (typeof data === "object" && data !== null) {
    if (
      data.expected_configuration &&
      typeof data.expected_configuration === "string"
    ) {
      // Return only the XML content, properly formatted
      return formatXmlString(data.expected_configuration);
    }
  }

  // Fallback to regular JSON formatting if no XML content found
  return JSON.stringify(data, null, 2);
};
